// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "yearInReview." + "main" + "." + "1755c6c67c982b12acf0" + ".css";
};